import { lazy } from "react";
import { Navigate } from "react-router-dom";
const BYOD = lazy(() => import("@/pages/dashboard/byod/BYOD"));
const Prices = lazy(() => import("@/pages/dashboard/prices/Prices"));
const PricesDetailsPage = lazy(() => import("@/pages/dashboard/prices/details-page/PricesDetailsPage"));
const Analysis = lazy(() => import("@/pages/dashboard/analysis"));
const Setting = lazy(() => import("@/pages/dashboard/setting/Setting"));
const Profile = lazy(() => import("@/pages/dashboard/Profile"));
const ViewDocument = lazy(() => import("@/shared/common/viewDocument/ViewDocument"));
const Clients = lazy(() => import("@/pages/dashboard/clients/ClientOnboarding"));
const PolicyTemplates = lazy(() => import("@/pages/dashboard/policies/policy-templates"));
const PolicyForms = lazy(() => import("@/pages/dashboard/policies/forms"));
const CreatePolicyTemplate = lazy(() => import("@/pages/dashboard/policies/policy-templates/create/createPolicyTemplate"));
const PolicyTemplateContextProvider = lazy(() => import("@/context/policyTemplateContext"));
const DynamicFormForPolicy = lazy(() => import("@/pages/dashboard/policies/forms/dynamic/DynamicFormForPolicy"));
const PolicyFormContextProvider = lazy(() => import("@/context/policyFormContext"));
const PolicyPreview = lazy(() => import("@/pages/dashboard/policies/forms/preview"));
const AdminUser = lazy(() => import("@/pages/admin/User/AdminUser"));
const AdminApiKey = lazy(() => import("@/pages/admin/api-key"));
const AdminSettings = lazy(() => import("@/pages/admin/setting/AdminSettings"));
const Portfolio = lazy(() => import("@/pages/dashboard/portfolio/Portfolio"));
const PortfolioGroup = lazy(() => import("@/pages/dashboard/portfolioGroup/PortfolioGroup"));
const ClientDetails = lazy(() => import("@/pages/dashboard/new-clients/components/ClientDetails"));
const IssuerDetails = lazy(() => import("@/pages/dashboard/new-issuer/components/IssuerDetails"));
const PortfolioGroupNew = lazy(() => import("@/pages/dashboard/portfoliogroup-new/index"));
const PortfolioNew = lazy(() => import("@/pages/dashboard/portfolio-new/index"));
const PortfolioGroupForm = lazy(() => import("@/pages/dashboard/portfoliogroup-new/components/PortfolioGroupForm"));
const PortfolioForm = lazy(() => import("@/pages/dashboard/portfolio-new/components/PortfolioForm"));
const ToleranceManager = lazy(() => import("@/pages/dashboard/tolerance-manager/Index"));
const AllocationNew = lazy(() => import("@/pages/dashboard/allocation-new"));
const NewIssuer = lazy(() => import("@/pages/dashboard/new-issuer"));
const NewClients = lazy(() => import("@/pages/dashboard/new-clients"));
const NewAssets = lazy(() => import("@/pages/dashboard/new-assets"));
const AddAsset = lazy(() => import("@/pages/dashboard/new-assets/components/AddAsset"));
const AssetDetails = lazy(() => import("@/pages/dashboard/new-assets/components/AssetDetails"));
const AddIssuer = lazy(() => import("@/pages/dashboard/new-issuer/components/AddIssuer"));
// Control workspace (IPM W1/W2)
const ComplianceDashboard = lazy(() => import("@/pages/dashboard/compliance"));
const ComplianceRules = lazy(() => import("@/pages/dashboard/compliance/rules"));
const ComplianceRuleDetail = lazy(() => import("@/pages/dashboard/compliance/rules/RuleDetail"));
const ComplianceMonitoring = lazy(() => import("@/pages/dashboard/compliance/monitoring"));
const ComplianceExposure = lazy(() => import("@/pages/dashboard/compliance/exposure"));
const ComplianceTrace = lazy(() => import("@/pages/dashboard/compliance/trace"));
const ComplianceDataQuality = lazy(() => import("@/pages/dashboard/compliance/data-quality"));
const ComplianceDataFeeds = lazy(() => import("@/pages/dashboard/compliance/data-feeds"));
const ComplianceFx = lazy(() => import("@/pages/dashboard/compliance/fx"));
const ComplianceEntities = lazy(() => import("@/pages/dashboard/compliance/entities"));
const ComplianceReference = lazy(() => import("@/pages/dashboard/compliance/reference"));
const ComplianceIngest = lazy(() => import("@/pages/dashboard/compliance/ingest"));
const ComplianceCases = lazy(() => import("@/pages/dashboard/compliance/cases"));
const ComplianceAttestations = lazy(() => import("@/pages/dashboard/compliance/attestations"));
const ComplianceDocuments = lazy(() => import("@/pages/dashboard/compliance/documents"));
const ComplianceDocumentViewer = lazy(() => import("@/pages/dashboard/compliance/documents/DocumentViewer"));
const ComplianceDocumentDetail = lazy(() => import("@/pages/dashboard/compliance/documents/DocumentDetail"));
const ComplianceMandateDetail = lazy(() => import("@/pages/dashboard/compliance/documents/MandateDetail"));
const ComplianceReports = lazy(() => import("@/pages/dashboard/compliance/reports"));
const ComplianceAudit = lazy(() => import("@/pages/dashboard/compliance/audit"));
const AiGovernance = lazy(() => import("@/pages/dashboard/compliance/ai-governance"));
const ComplianceInstruments = lazy(() => import("@/pages/dashboard/compliance/instruments"));
const TradeImpact = lazy(() => import("@/pages/dashboard/compliance/trade-impact"));
const NotificationsPage = lazy(() => import("@/pages/dashboard/Notifications"));
const OrganisationPage = lazy(() => import("@/pages/dashboard/Organisation"));
const ExitPage = lazy(() => import("@/pages/dashboard/Exit"));

export const route = [
    {
        path: "/compliance",
        ele: <ComplianceDashboard />,
        permission: 'user',
    },
    {
        path: "/compliance/rules",
        ele: <ComplianceRules />,
        permission: 'user',
    },
    {
        path: "/compliance/rules/:ruleId",
        ele: <ComplianceRuleDetail />,
        permission: 'user',
    },
    {
        path: "/compliance/monitoring",
        ele: <ComplianceMonitoring />,
        permission: 'user',
    },
    {
        // W67 (UI-002): exposure by dimension, and limits with headroom by rule.
        path: "/compliance/exposure",
        ele: <ComplianceExposure />,
        permission: 'user',
    },
    {
        // W68 (UI-007): the traceability chain, walked from any link of it.
        path: "/compliance/trace/:type/:id",
        ele: <ComplianceTrace />,
        permission: 'user',
    },
    {
        path: "/compliance/data-quality",
        ele: <ComplianceDataQuality />,
        permission: 'user',
    },
    {
        path: "/compliance/data-feeds",
        ele: <ComplianceDataFeeds />,
        permission: 'user',
    },
    {
        path: "/compliance/entities",
        ele: <ComplianceEntities />,
        permission: 'user',
    },
    {
        path: "/compliance/ingest",
        ele: <ComplianceIngest />,
        permission: 'user',
    },
    {
        path: "/compliance/reference",
        ele: <ComplianceReference />,
        permission: 'user',
    },
    {
        path: "/compliance/fx",
        ele: <ComplianceFx />,
        permission: 'user',
    },
    {
        path: "/compliance/instruments",
        ele: <ComplianceInstruments />,
        permission: 'user',
    },
    {
        path: "/compliance/trade-impact",
        ele: <TradeImpact />,
        permission: 'user',
    },
    {
        path: "/account/notifications",
        ele: <NotificationsPage />,
        permission: 'user',
    },
    {
        path: "/compliance/cases",
        ele: <ComplianceCases />,
        permission: 'user',
    },
    {
        path: "/compliance/attestations",
        ele: <ComplianceAttestations />,
        permission: 'user',
    },
    {
        path: "/compliance/documents",
        ele: <ComplianceDocuments />,
        permission: 'user',
    },
    {
        path: "/compliance/mandates/:mandateId",
        ele: <ComplianceMandateDetail />,
        permission: 'user',
    },
    {
        // Declared BEFORE /compliance/documents/:documentId so the literal
        // "versions" segment cannot be read as a document id (§5.3: route
        // order matters; first declared wins).
        path: "/compliance/documents/versions/:versionId",
        ele: <ComplianceDocumentViewer />,
        permission: 'user',
    },
    {
        path: "/compliance/documents/:documentId",
        ele: <ComplianceDocumentDetail />,
        permission: 'user',
    },
    {
        path: "/compliance/reports",
        ele: <ComplianceReports />,
        permission: 'user',
    },
    {
        path: "/compliance/audit",
        ele: <ComplianceAudit />,
        permission: 'user',
    },
    {
        // AI-008...011. Readable by any member: which model has been reading
        // this organisation's policy documents is not administrative trivia.
        path: "/compliance/ai-governance",
        ele: <AiGovernance />,
        permission: 'user',
    },
    {
        path: "/account/organisation",
        ele: <OrganisationPage />,
        permission: 'user',
    },
    {
        // EXIT-001...004. Readable by any member on purpose: deciding whether
        // to depend on a product should not require starting to leave it.
        path: "/account/exit",
        ele: <ExitPage />,
        permission: 'user',
    },
    {
        path: "/portfolio/:slug",
        ele: <PortfolioGroup />,
        permission: 'user',
    },
    {
        // The first segment is the portfolio group, the second the portfolio.
        // Two params cannot share a name — React Router binds only the last.
        path: "/portfolio/:groupSlug/:slug",
        ele: <Portfolio />,
        permission: 'user',
    },
    {
        // The single consolidated allocation surface (ALC-006): entry panel
        // when nothing is loaded, manage surface once an allocation is chosen.
        path: "/allocation",
        ele: <AllocationNew />,
        permission: 'user',
    },
    {
        // Old deep links from the retired two-page flow.
        path: "/allocation/manage-allocation",
        ele: <Navigate to="/allocation" replace />,
        permission: 'user',
    },
    {
        // W117: the manager's analysis (it replaced the indicator chart builder).
        path: "/analysis",
        ele: <Analysis />,
        permission: 'user',
    },
    {
        // The page's old address, kept for bookmarks.
        path: "/reporting",
        ele: <Navigate to="/analysis" replace />,
        permission: 'user',
    },
    // LATEST ISSUERS ROUTES
    {
        path: "/data/issuers/dashboard",
        ele: <NewIssuer />,
        permission: 'user',
    },
    {
        path: "/data/issuer/add",
        ele: <AddIssuer />,
        permission: 'user',
    },
    {
        path: "/data/issuer/update/:id",
        ele: <AddIssuer />,
        permission: 'user',
    },
    {
        path: "/data/issuer/:id",
        ele: <IssuerDetails />,
        permission: 'user',
    },
    // LATEST ASSETS ROUTES
    {
        path: "/data/assets/dashboard",
        ele: <NewAssets />,
        permission: 'user',
    },
    {
        path: "/data/asset/add",
        ele: <AddAsset />,
        permission: 'user',
    },
    {
        path: "/data/asset/update/:id",
        ele: <AddAsset />,
        permission: 'user',
    },
    {
        path: "/data/asset/:id",
        ele: <AssetDetails />,
        permission: 'user',
    },
    {
        path: "/data/prices",
        ele: <Prices />,
        permission: 'user',
    },
    {
        path: "/data/prices/:slug",
        ele: <PricesDetailsPage />,
        permission: 'user',
    },
    {
        path: "/data/BYOD",
        ele: <BYOD />,
        permission: 'user',
    },
    {
        path: "/account/setting",
        ele: <Setting />,
        permission: 'user',
    },
    {
        path: "/account/profile",
        ele: <Profile />,
        permission: 'user',
    },
    {
        path: "/view/file/:fileName",
        ele: <ViewDocument />,
        permission: 'user',
    },
    {
        path: "/onboard-client/add",
        ele: <><Clients /></>,
        permission: 'user',
    },
    {
        path: "/clients/dashboard",
        ele: <><NewClients /></>,
        permission: 'user',
    },
    {
        path: "/onboard-client/:id",
        ele: <><ClientDetails /></>,
        permission: 'user',
    },
    {
        path: "/onboard-client/update/:id",
        ele: <><Clients /></>,
        permission: 'user',
    },
    {
        path: "/policies/templates",
        ele: <PolicyTemplateContextProvider><PolicyTemplates /></PolicyTemplateContextProvider>,
        permission: 'user',
    },
    {
        path: "/policies/templates/:id/config",
        ele: <PolicyTemplateContextProvider><CreatePolicyTemplate /></PolicyTemplateContextProvider>,
        permission: 'user',
    },
    {
        path: "/policies/forms",
        ele: <PolicyFormContextProvider><PolicyForms /></PolicyFormContextProvider>,
        permission: 'user',
    },
    {
        path: "/policies/forms/:formId",
        ele: <PolicyFormContextProvider><DynamicFormForPolicy /></PolicyFormContextProvider>,
        permission: 'user',
    },
    {
        path: "/policies/forms/:formId/preview",
        ele: <PolicyFormContextProvider><PolicyPreview /></PolicyFormContextProvider>,
        permission: 'user',
    },
    {
        path: '/data/portfolio-groups',
        ele: <PortfolioGroupNew />,
        permission: 'user'
    },
    {
        path: '/data/portfolio-groups/add',
        ele: <PortfolioGroupForm />,
        permission: 'user'
    },
    {
        path: '/data/portfolio-groups/update/:id',
        ele: <PortfolioGroupForm />,
        permission: 'user'
    },
    {
        path: '/data/portfolios',
        ele: <PortfolioNew />,
        permission: 'user'
    },
    {
        path: '/data/portfolios/add',
        ele: <PortfolioForm />,
        permission: 'user'
    },
    {
        path: '/data/portfolios/update/:id',
        ele: <PortfolioForm />,
        permission: 'user'
    },
    {
        path: '/tolerance-manager',
        ele: <ToleranceManager />,
        permission: 'user'
    },
    // admin Routes
    {
        path: "/admin/user",
        ele: <AdminUser />,
        permission: 'admin',
    },
    {
        path: "/admin/api-key",
        ele: <AdminApiKey />,
        permission: 'admin',
    },
    {
        path: "/admin/account/setting",
        ele: <AdminSettings />,
        permission: 'admin',
    },
]